import React, { useEffect, useState } from 'react';
import { Select, SelectItem } from '@nextui-org/react';
import { getAvailableVarietiesWithCounts } from 'common/src/api/settlements';
import useUserStore from '../../stores/useUserStore';
import useFilterStore from '../../stores/useFiltersStore';
import useDataStore from '../../stores/useDataStore';

interface CostsVarietyFilterProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  className?: string;
  onVarietiesLoaded?: (mostCommon: string | null) => void;
}

const CostsVarietyFilter: React.FC<CostsVarietyFilterProps> = ({
  value,
  onChange,
  disabled,
  className,
  onVarietiesLoaded,
}) => {
  const { session } = useUserStore();
  const { selectedSeason } = useFilterStore();
  const { selectedSpecies } = useDataStore();
  // Removed unused varieties state
  const [varietiesWithCount, setVarietiesWithCount] = useState<
    Array<{ variety: string; count: number; kilos: number }>
  >([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchVarieties = async () => {
      if (!session?.access_token || !selectedSeason || !selectedSpecies?.id)
        return;

      setLoading(true);
      try {
        const result = await getAvailableVarietiesWithCounts(
          session,
          selectedSeason,
          selectedSpecies.id
        );
        setVarietiesWithCount(result.varietiesWithCount);

        // Notify parent about the most common variety
        if (onVarietiesLoaded) {
          onVarietiesLoaded(result.mostCommon);
        }
      } catch (error) {
        console.error('Error fetching varieties:', error);
        setVarietiesWithCount([]);
      } finally {
        setLoading(false);
      }
    };

    fetchVarieties();
  }, [
    session?.access_token,
    selectedSeason,
    selectedSpecies?.id,
    onVarietiesLoaded,
  ]);

  // Ensure the value exists in available options
  const availableKeys = ['all', ...varietiesWithCount.map((v) => v.variety)];
  const validValue = value && availableKeys.includes(value) ? value : '';

  return (
    <Select
      label='Variedad'
      placeholder='Seleccionar variedad'
      selectedKeys={validValue ? new Set([validValue]) : new Set()}
      onSelectionChange={(keys) => {
        const selectedValue = Array.from(keys)[0] as string;
        onChange(selectedValue || 'all');
      }}
      className={className}
      isDisabled={disabled || loading}
      description={loading ? 'Cargando variedades...' : ''}
      items={[
        { key: 'all', label: 'Todas las variedades' },
        ...varietiesWithCount.map(({ variety }) => ({
          key: variety,
          label: variety,
        })),
      ]}
    >
      {(item) => <SelectItem key={item.key}>{item.label}</SelectItem>}
    </Select>
  );
};

export default CostsVarietyFilter;
